import {
    SETUP,
    FETCH_COMPANIES,
    SAVE_COMPANY,
    DELETE_COMPANY,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP:
            return action.payload.budgetsApp.companies;
        case FETCH_COMPANIES:
            return action.payload;
        case SAVE_COMPANY:
            if (action.meta && action.meta.companyId) {
                return state.map(company => company.id === action.meta.companyId ? action.payload : company);
            }
            return state.concat(action.payload);
        case DELETE_COMPANY:
            return state.filter(company => company.id !== action.meta.companyId);
        default:
            return state;
    }
};
